import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectSectionUnitFormFile } from '../models/project/project-section-unit-form-file.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectSectionUnitFormFileService extends RequestService<ProjectSectionUnitFormFile> {
  static PATH = '/project/section/unit/form/file';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(
      httpClient,
      ProjectSectionUnitFormFileService.PATH,
      globalService.debugUrl
    );
  }
}
